import { loader } from "./loader.module";
import { configs } from "./configs.module";
import { authentication } from "./authentication.module";
import { alert } from "./alert.module";
import { paymentTypes } from "./paymentTypes.module";
import { salesmen } from "./salesmen.module";
import { cashDrawers } from "./cashDrawers.module";
import { families } from "./families.module";
import { items } from "./items.module";
import { cart } from "./cart.module";
import { countries } from "./countries.module";
import { stores } from "./stores.module";
import { modelExtension } from "./modelExtension.module";
import { dataLog } from "./dataLog.module";
import { docTypes } from "./docTypes.module";
import { tenants } from "./tenants.module";
import { createStore } from "vuex";

export const store = createStore({
  state() {
    return {
      tenant: null,
      store: null,
    };
  },
  mutations: {
    setTenant(state, tenant) {
      state.tenant = tenant;
    },
    setStore(state, store) {
      state.store = store;
    },
  },
  actions: {
    updateTenant({ commit }, tenant) {
      commit("setTenant", tenant);
    },
    updateStore({ commit }, store) {
      commit("setStore", store);
    },
  },
  getters: {
    tenant(state) {
      return state.tenant;
    },
    store(state) {
      return state.store;
    },
  },
  modules: {
    authentication,
    alert,
    loader,
    configs,
    paymentTypes,
    salesmen,
    cashDrawers,
    families,
    items,
    cart,
    countries,
    stores,
    modelExtension,
    dataLog,
    docTypes,
    tenants,
  },
});
